/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { HtmlPage } from '../../../widgets/landing-page-widget';
import { VerifyFailurePageService } from '../../../services';
import { VApplication } from '../../../application';
import { useTheme } from '../../../providers/theme';
import { useSMVerifyProductPage } from '../machines/pageContent';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import MiddleBlock from '../components/MiddleBlock';
import './custom.css';
import Image from 'react-bootstrap/Image';
import { useLocation } from 'react-router-dom';
import { LOGO } from "../../../assets"
import { Navbar } from 'react-bootstrap';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.VerifyFailurePageService'
  ) as VerifyFailurePageService;
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const srv = getSrv();
  const location = useLocation();
  const { width, height, bp } = useViewport();
  const staticPageContentConfig = srv?.getStaticPageContent();
  const [buttonItem, setButtonItem] = useState();

  const { verifyProductPageState } = useSMVerifyProductPage({});
  const content = staticPageContentConfig?.CONTENT;

  console.log(`location state value in failure container :`, location?.state);
  return (
    <>
      {/* <HtmlPage
        {...(verifyProductPageState?.event?.data?.value || {})}
        secondaryColor={theme?.colors?.secondary}
        buttonItem={buttonItem}
      > */}
      <div className='bubble' />
      <div className='bottomBubble' />
      <div className='bottomRectangle' />
      <div className='container' />
      <div className='headerLogoContainer'>
        <Image
          src={LOGO}
          width={'30%'}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: height - 102,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MiddleBlock
            title={content.title}
            content={content.text}
            button={content.button}
            onClick={props?.onClick}
            section={content.section}
            id={content.id}
            scrollTo={content.scrollTo}
            key={`landing-page-middle`}
            link={content.link}
            color={props.color}
            secondaryColor={props.secondaryColor}
            onFocusColor={props?.onFocusColor}
            titleStyle={content.titleStyle}
            contentStyle={content.contentStyle}
            buttonPrimaryColor={content.buttonPrimaryColor}
            buttonSecondaryColor={content.buttonSecondaryColor}
            buttonFocusColor={content.buttonFocusColor}
          />
          <img src={'https://i.ibb.co/C9wkWQ2/close.png'} width={'40%'} />
          {location?.state?.image ? (
            <img
              src={location?.state?.image}
              alt={content.text}
              width={'80%'}
              height={height * 0.3}
              style={{ objectFit: 'contain' }}
            />
          ) : (
            <div style={{ height: height * 0.3 }} />
          )}
          <div className='poweredByFooter'
        >
          <span>Powered by</span>
          <Navbar.Brand
            // as={HashLink}
            // to={"https://vlinder.io/"}
            href='https://vlinder.io/'
            className='me-lg-3 ms-2 d-flex align-items-center'
          >
            <Image src={"https://s3.ap-south-1.amazonaws.com/io.vlinder.public/vlinder-logo.png"} style={{ backgroundColor: "white" }} />
            <span
              className='ms-2 brand-text text-white'
              style={{
                fontFamily: "muli"
              }}
            >
              {"Vlinder"}
            </span>
          </Navbar.Brand>
        </div>
        </div>
      </div>
    </>
  );
};